var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.imageSrc)?_c('div',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageSrc),expression:"imageSrc"}],staticClass:"img-fluid rounded image-small",attrs:{"src":_vm.imageSrc,"alt":"Responsive image"}})]):_c('div',[_c('font-awesome-icon',{staticClass:"image-small",attrs:{"icon":"image"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }